import React, { Fragment, useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import {
  AppContext,
  SET_APP_ALL,
  SocketCommand,
  socketManager,
} from "../../../components/AppProvider";
import { AlertLayer } from "../../../components/UI/Dialog";
import { PostApi1916 } from "../../../modules/network/padoPost";
import { setCookie } from "../../../modules/utils/cookie";
import { Container, openLayerFn } from "../../Layout";
import { requestHsptList } from "../../Reservation/Surround";
import { MapView } from "../../common/Modal/NaverMap";
import { PostApi1913 } from "./../../../modules/network/padoPost";
import ConnectHospitalLayer from "./ConnectHospitalLayer";
import LimitTrsmLayer from "./LimitTrsmLayer";
import SearchBox from "./SearchBox";
import SearchList from "./SearchList";
import ShareList from "./ShareList";
import { GetGpsInfo } from "../../../modules/utils/GetGpsInfo";
import useTitle from "../../../modules/hooks/useTitle";

export default props => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);

  const [searchList, setSearchList] = useState([]);
  const [searchType, setSearchType] = useState(
    parseInt(props.match.params.regist)
  ); // 0 검색, 1 주변
  const [locationInfo, setLocationInfo] = useState({});

  const [hpList, setHpList] = useState([]);
  const [sharHsptList, setSharHsptList] = useState([]);
  const [targetList, setTargetList] = useState([]);
  const [hsptNm, setHsptNm] = useState();
  const [hpKey, setHpKey] = useState();
  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    url: "",
  });

  const handleAlert = (title, msg, url) => {
    setDialog({
      title: title,
      msg: msg,
      url: url,
    });

    openLayerFn($(".alert-layer"));
  };

  const changeTap = type => {
    resetPaging();
    setSearchType(type);
  };

  const resetPaging = () => {
    setSharHsptList([]);
    setSearchList([]);
    setTargetList([]);
    setDisplayList([]);
    setLastIndex(1);
    setResetState(true);
  };

  const settingTrgtList = (target, type) => {
    if (searchType === 0) {
      if (type === "PUSH") {
        settingTargetPreview(target, targetList, setTargetList);
      } else {
        settingTargetOn2(target, targetList, setTargetList);
      }
    } else {
      settingTargetOn(target, targetList, setTargetList);
    }
  };

  const loadSharHspt = () => {
    setSharHsptList([]);
    PostApi1913(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          dispatch({ type: SET_APP_ALL, data: res.result });
          setSharHsptList(res.result.sharHsptList);
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useTitle("마이페이지_병원연동");

  useEffect(() => {
    setCookie("toDayNotAddHspt", "Y", 1);
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 81) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    } else if (phonecfg.phoneOS === "IOS") {
      if (parseInt(phonecfg.version.split(".")[2]) > 35) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    }
  }, []);

  useEffect(() => {
    if (searchType == 1) {
      requestHsptList(
        userinfo,
        cfg,
        phonecfg,
        "A",
        $("#tags").val(),
        setSearchList
      );
    } else {
      loadSharHspt();
    }
  }, [searchType]);

  const connectEvent = (hpKey, hsptNm) => {
    setHpKey(hpKey);
    setHsptNm(hsptNm);
    openLayerFn($(".confirm-layer"));
  };

  const { ref, inView } = useInView();

  const [lastIndex, setLastIndex] = useState(1);
  const [displayList, setDisplayList] = useState([]);
  const [resetState, setResetState] = useState(true);

  const CPP = 20;

  useEffect(() => {
    const tList =
      searchList &&
      Array.isArray(searchList) &&
      searchList.filter(
        (i, index) => index >= (lastIndex - 1) * CPP && index < lastIndex * CPP
      );

    if (resetState) {
      setDisplayList(tList);
      setResetState(false);
    } else {
      setDisplayList([...(displayList ?? []), ...(tList ?? [])]);
    }
  }, [lastIndex, searchList]);

  useEffect(() => {
    if (!searchList || !Array.isArray(searchList)) {
      resetPaging();
      // return;
    } else if (inView && lastIndex * CPP < searchList.length) {
      if (resetState === false) {
        setLastIndex(lastIndex + 1);
      } else {
        setLastIndex(1);
      }
    }
  }, [inView]);

  const goBackURL = params => {
    if (params === "proof") {
      return "/pmr/proofRecipt";
    } else if (params === "other") {
      return "pmr/otherinspaction";
    } else if (params === "trtmtData") {
      return "/pmr/treatmentData";
    } else if (params === "setting") {
      return "/mp/settings/0";
    } else if (params === "mp") {
      return "/mp";
    } else {
      return "/";
    }
  };

  return (
    <Fragment>
      <Container
        Title="병원연동 및 개인데이터 공유"
        dark="dark"
        goToUrl={goBackURL(props.match.params.returnPage)}
        // goToUrl={
        //   props.match.params.returnPage
        //     ? goBackURL(props.match.params.returnPage)
        //     : "/mp/settings/0"
        // }
      >
        <div className="contents">
          <div className="sub-contents">
            <div className="pr-section">
              <div
                className="pr-section-tt"
                style={{ textAlign: "left", color: "#888" }}>
                <p>
                  케어포미의 데이터는 휴대폰에 저장되며 사용자의 동의하에 연동된
                  병원에 진료를 목적으로 개인 데이터를 공유 할 수 있습니다.
                </p>
              </div>

              <div
                className="round-blue-tab green"
                style={{ display: "flex", backgroundColor: "#fff" }}>
                {/* <a>현위치</a> */}

                <a
                  className={searchType === 1 ? "on" : ""}
                  onClick={() => changeTap(1)}
                  style={{
                    width: "45%",
                    backgroundColor: searchType === 1 ? "#000" : "#888",
                    color: "#fff",
                    borderRadius: "8px",
                  }}>
                  병원검색
                </a>
                <a
                  className={searchType === 0 ? "on" : ""}
                  style={{
                    marginLeft: "auto",
                    width: "45%",
                    backgroundColor: searchType === 0 ? "#000" : "#888",
                    color: "#fff",
                    borderRadius: "8px",
                  }}
                  onClick={() => {
                    changeTap(0);
                    loadSharHspt();
                  }}>
                  연동병원
                </a>
              </div>

              {searchType === 1 && (
                <SearchBox
                  setSearchList={setSearchList}
                  searchList={searchList}
                  settingTrgtList={settingTrgtList}
                  resetPaging={resetPaging}
                />
              )}
              {
                // (searchType === 0 && userinfo.app) && <PrivateDataShare setSearchList={setSearchList} data={sharHsptList} settingTrgtList={settingTrgtList} />
                searchType === 0 && userinfo.app && (
                  <div style={{ height: "20px" }} />
                )
              }

              <div className="linebox-info-list pb30">
                {/* 주변병원 */}
                {searchType === 1 &&
                  displayList.length > 0 &&
                  displayList.map(
                    (m, i) =>
                      m.addYn === "N" && (
                        <SearchList
                          key={"list" + i}
                          searchType={searchType}
                          data={m}
                          setLocationInfo={setLocationInfo}
                          connectEvent={connectEvent}
                        />
                      )
                  )}

                {/* 병원검색-선택한 병원리스트 */}
                {
                  searchType === 0 &&
                    sharHsptList.length > 0 &&
                    sharHsptList.map((m, i) => (
                      <ShareList
                        key={"share" + i}
                        searchType={searchType}
                        data={m}
                        setLocationInfo={setLocationInfo}
                        connectEvent={connectEvent}
                      />
                    ))
                  // : <div>연결 병원 없음</div>
                }
              </div>
              <div ref={ref} />
            </div>
          </div>
        </div>
      </Container>
      {/* <MapView locationInfo={locationInfo} /> */}
      <ConnectHospitalLayer
        hpKey={hpKey}
        hsptNm={hsptNm}
        setSearchType={setSearchType}
        handleAlert={handleAlert}
      />
      <LimitTrsmLayer />
      <MapView locationInfo={locationInfo} backTopColor={"#ffffff"} />
      <AlertLayer title={dialog.title} msg={dialog.msg} url={dialog.url} />
    </Fragment>
  );
};

export const addHspt = (userinfo, cfg, phonecfg, searchType, addList, handleAlert, regist) => {
    for(let i = 0; i < addList.length; i++) {
        let hpKey = addList[i];

        // searchType === 0 -> addList가 객체
        // searchType === 1 -> addList가 배열
        if(searchType === 0) {
            hpKey = hpKey.hsptKey;
        }

        PostApi1916(userinfo, cfg, phonecfg, 'hpKey', "Y", hpKey, '')
        .then(res => {
            if(res.resultMsg === 'SUCCESS') {
                if(i == (addList.length-1)) {
                    // regist true : 바로 인증번호 입력으로 넘어감 / false
                    if(!regist) {
                        handleAlert('', '병원 등록이 완료 되었습니다.', '/');
                    }
                }
            } else if(res.resultMsg === "LOGOUT") {
                // openLayerFn($(".alert-layer-logout"));
                handleAlert('', '다른 기기에 로그인한 계정입니다.', '/membership/login');
            } else {
                // handleConfirm("", "병원 등록에 실패 하였습니다.");
                handleAlert('', '병원 등록에 실패 하였습니다.', '/cnntHspt');
            }
        })
        .catch(err => {
            console.log(err);
        });
    }
}

const settingTargetPreview = (target, targetList, setTargetList) => {

    let targetArr;

    targetArr = targetList;
    targetArr = targetArr.filter((element) => element.hsptKey !== target.hsptKey)

    targetArr.push(target);
    $("#ui-id-1").hide();

    setTargetList(targetArr);
    $("#ui-id-1").hide();
    
}

const settingTargetOn = (target, targetList, setTargetList) => {
    let targetArr = targetList;
    
    if($("#"+target.hsptKey).hasClass('on')) {
        targetArr = targetArr.filter((element) => element !== target.hsptKey);
    } else {
        targetArr.push(target.hsptKey)
    }
    
    setTargetList(targetArr);
    $("#"+target.hsptKey).toggleClass("on");
}

const settingTargetOn2 = (target, targetList, setTargetList) => {
    let targetArr = targetList;
    
    if($("#"+target.hsptKey).hasClass('on')) {
        targetArr = targetArr.filter((element) => element !== target);
    } else {
        targetArr.push(target)
    }
    
    setTargetList(targetArr);
    $("#"+target.hsptKey).toggleClass("on");
}